import {
  CommonFormValues,
  commonFormInitialValues,
  commonFormValidationSchema
} from '@/utils/functions/form'
import { object, string } from 'yup'

export interface FormValues extends CommonFormValues {
  designation: string
}

export const initialFormValues = {
  ...commonFormInitialValues,
  designation: ''
}

export const validationSchema = commonFormValidationSchema.concat(
  object().shape({
    designation: string().required('Please enter your designation')
  })
)
